
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/slots/[id]",
      function () {
        return require("private-next-pages/slots/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/slots/[id]"])
      });
    }
  